import { Navigate, useParams } from "react-router-dom";

export default function Booking() {
  const { expertId } = useParams();
  return <Navigate to={`/beskriv-problem?ekspert=${expertId}`} replace />;
}
